import { Link, type RouteObject } from 'react-router-dom';
import { ROUTE_PATHS } from '@/constants/common';

export const consumerPoolRoute: RouteObject = {
  path: ROUTE_PATHS.consumerPool,
  lazy: async () => ({
    Component: (await import('@/pages/ConsumerPool')).default,
  }),
  handle: {
    title: '消费者池',
    crumb: () => <Link to={ROUTE_PATHS.consumerPool}>消费者池</Link>,
  },
};
